import { validateZipCodeModal } from '../utils/queries';
import useZipcode from './useZipcode';
import React, { useCallback } from 'react';
import useDevice from '../../common/hooks/useDevice';
import useApolloQuery from '../../common/hooks/useApolloQuery';
export default ({
  showing,
  handleHide,
  setShowing,
  withCity = false,
  component: Component,
  zipCodeLink
}) => {
  const location = useZipcode({
    withCity
  });
  const deviceData = useDevice();
  const {
    data,
    loading
  } = useApolloQuery(validateZipCodeModal, {
    ssr: true,
    skip: !showing
  });
  const {
    privacyPolicyUrl,
    valuesOutsideUsUrl
  } = data || {};
  const valuesOutsideUsUrlCallback = useCallback(event => {
    event.preventDefault();
    if (valuesOutsideUsUrl) {
      window.open(valuesOutsideUsUrl, '_blank', '');
      return false;
    }
  }, [valuesOutsideUsUrl]);
  if (!showing || loading) {
    return null;
  }
  const onHide = () => {
    handleHide ? handleHide() : setShowing(false);
    if (zipCodeLink) {
      zipCodeLink.focus();
    }
  };
  return React.createElement(Component, {
    showing: showing,
    handleHide: onHide,
    location: location,
    privacyPolicyUrl: privacyPolicyUrl,
    acceptGeoLocation: deviceData?.istablet || deviceData?.issmartphone,
    valuesOutsideUsUrl: valuesOutsideUsUrlCallback
  });
};